import * as React from "react";
import { Outlet } from "@tanstack/react-router";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

/**
 * Root Layout Component
 *
 * This is the root layout for the entire application.
 * It wraps all pages with:
 * - AuthProvider: Provides authentication context
 * - Toaster: Toast notifications (sonner)
 */
export function RootLayout() {
  return (
    <AuthProvider>
      {/* Main content outlet */}
      <Outlet />

      {/* Global toast notifications */}
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}
